// Cache-bust the tank photo URL by keying off the freshest thing that
// changes whenever the user could have uploaded a new photo. The score
// recomputes on any data write (including the photo upload itself), so
// score_computed_at is the cheapest stable handle. Falls back to
// latest_reading_ts (a tank with a photo but no scored params yet)
// and finally to the base URL if neither is available.
export function tankPhotoUrl(tank) {
  const id = tank?.id;
  if (!id) return null;
  const base = `/api/tanks/${id}/photo`;
  const v = tank.score_computed_at || tank.latest_reading_ts;
  if (!v) return base;
  const t = v instanceof Date ? v.getTime() : new Date(v).getTime();
  return Number.isFinite(t) ? `${base}?v=${t}` : base;
}
